import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

const Breadcrumbs = ({ crumbs = [] }) => {
  // <-- default to empty array

  const history = useHistory();

  const routeToPage = (data) => {
    history.push({
      pathname: data.path,
    });
  };

  useEffect(() => {
    // optional: you can log crumbs if needed
    console.log("Breadcrumbs updated:", crumbs);
  }, [crumbs]);

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {crumbs.map((crumb, idx) => (
          <li
            key={idx}
            className={`breadcrumb-item ${
              idx === crumbs.length - 1 ? "active" : ""
            } ${crumb.isBack ? "breadcrumb-back" : ""}`}
            {...(idx === crumbs.length - 1 ? { "aria-current": "page" } : {})}
          >
            {crumb.path && idx !== crumbs.length - 1 ? (
              <a onClick={() => routeToPage(crumb)}>{crumb.label}</a>
            ) : (
              crumb.label
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
